import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
export const CrewComplement = ({ options }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    useEffect(() => {
        if (!options.isReady)
            return;
        setData(null);
        setLoading(true);
        const params = new URLSearchParams({
            vesselTypes: options.vesselTypes.join(","),
            fleets: options.fleet.map((f) => f.ID).join(","),
        });
        fetch(`/api/crewcomplement?${params}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((summary) => {
            setData(summary);
        })
            .catch(() => {
            notifyError("An error has occurred when loading crew complement data. Please try again.");
        })
            .finally(() => setLoading(false));
    }, [options.isReady, options.vesselTypes.join(","), options.fleet.map((f) => f.ID).join(",")]);
    const hasData = data !== null;
    const fleetAverage = hasData ? Math.round(data.UserFleetCrewComplement * 100) / 100 : null;
    const industryAverage = hasData ? Math.round(data.IndustryCrewComplement * 100) / 100 : null;
    return (_jsx(BenchmarkCard, { bodyClassName: "pt-3", children: loading ? (_jsx(WkoLoadingSpinner, {})) : !hasData ? (_jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) })) : (_jsxs(_Fragment, { children: [_jsxs("h2", { children: ["Current crew complement: ", _jsx("span", { children: fleetAverage })] }), _jsxs("h3", { children: ["Industry equivalent: ", _jsx("span", { children: industryAverage })] })] })) }));
};
